import { TrackEventVerb } from '@updater/ui-tracker';

export type TrackEventVerbDict = {
  [key: string]: TrackEventVerb;
};

/**
 * @enum {Object{String}} DOMAIN
 * @description dictionary that contains the analytics domain type.
 */
export enum DOMAIN {
  FORWARD_MAIL = 'forward-mail',
}

/**
 * @enum {Object{String}} VERB
 * @description dictionary that contains the analytics verbs type.
 */
export enum VERB {
  CLICKED = 'clicked',
  ERRORED = 'errored',
  SUBMITTED = 'submitted',
  VIEWED = 'viewed',
}

/**
 * @enum {Object{String}} OBJECT
 * @description dictionary contains the analytics object type.
 */
export enum OBJECT {
  BACK_BUTTON = 'backButton',
  CANCEL_BUTTON = 'cancelFormButton',
  CLICKED = 'clicked',
  EDIT_FORM = 'EditFormButton',
  FORM = 'form',
  NEW_FORM = 'newFormButton',
  NEXT_BUTTON = 'nextButton',
  PHONE_VERIFIED_BUTTON = 'phoneVerifiedButton',
  SEND_CODE_BUTTON = 'sendCodeButton',
  SUBMIT_BUTTON = 'submitButton',
  SUBMITTED_FORM = 'submittedForm',
  SUBMIT_QUERY = 'submit-query',
  CREDIT_CARD_VERIFIED_BUTTON = 'credit-card-verified-button',
  VERIFY_PHONE = 'verify-phone',
  RECEIPT = 'receipts',
  WHOS_MOVING_CARD = 'who-is-moving-card',
  VERIFY_CREDIT_CARD = 'verify-cc',
  COMPLETED_CARD = 'completed-card',
  ENTRY_POINT = 'entry_point',
  NON_INVITED_USER = 'non-invited-user',
}

/**
 * @enum {Object{String}} PAGE
 * @description dictionary contains the analytics page name.
 */
export enum PAGE {
  SUBMISSION = 'submission',
  SUBMITTED_FORMS = 'submitted-forms',
  VERIFY_PHONE = 'verify-phone',
  VERIFY_CREDIT_CARD = 'verify-cc',
  RECEIPTS = 'receipts',
  ENTRY_POINT = 'entry_point',
}
